module.exports = __webpack_public_path__ + "img/672.fce7dea6.png";